import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputText } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-sign-in',
  imports: [CommonModule, InputText, ButtonDirective, ReactiveFormsModule],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss',
})
export class SignInComponent {
  private angularFireAuth = inject(AngularFireAuth);
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);

  protected form = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    senha: ['', Validators.required],
  });

  protected signWithEmailAndPassword() {
    const { email, senha } = this.form.value;
    this.angularFireAuth
      .signInWithEmailAndPassword(<string>email, <string>senha)
      .then(() => this.router.navigate(['/']))
      .catch((error) => console.error(error));
  }
}
